// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3q5nr","fullView":"styles_fullView__LIZPZ"};